import * as React from 'react';
import { cn } from '@/utils/cn';

interface MockUserBubbleProps {
  message: string;
  compact?: boolean;
  className?: string;
}

export const MockUserBubble: React.FC<MockUserBubbleProps> = ({ message, compact, className }) => (
  <div className={cn('mb-6 flex w-full flex-col items-end', className)}>
    <div
      className={cn(
        // Base Bubble Styles
        'relative w-fit',
        compact ? 'px-4 py-3' : 'px-6 py-5',
        'glass-bubble', // Bubble-specific glass utility
        'backdrop-blur-none md:backdrop-blur-md',

        // User Specific Styles
        'bg-user-bubble-gradient', // Gradient #120220 -> #5438A0
        'text-white',
        'rounded-24',
        'max-w-[417px]',

        // Typography
        compact
          ? 'font-sans text-14 font-medium leading-160 tracking-neg-2 xl:text-14'
          : 'font-sans text-14 font-medium leading-160 tracking-neg-2 xl:text-16'
      )}
    >
      <p className='whitespace-pre-wrap break-words'>{message}</p>
    </div>
  </div>
);
